<template>
    <section id="mainContainer">
      <section class="login-page">
        <div class="login-container">
          <div class="admin-white-bg admin-custom-row">
            <div class="admin-login-left">
              <div class="admin-logo">
                <img src="@/assets/images/logo.svg" alt="Admin Logo" />
              </div>
              <h1>{{ constants.FORGOT_PASSWORD_TEXT }}</h1>
              <div class="admin-login-form">
                <form id="forgotPwtForm" @submit.prevent="sendEmail">
                  <div class="login-input">
                    <label>{{ constants.EMAIL_LABEL }}</label>
                    <input
                    id="forgotPwtEmailInput"
                      type="text"
                      v-model="email"
                      placeholder="Enter Email address"
                    />
                    <div class="error-msg" v-if="!email||errorMsg==='Email not registered.'">{{errorMsg}}</div>
                  </div>
                  <button id="forgotPwtSubmitBtn" type="submit" class="primary-btn">
                    {{ constants.SEND_EMAIL_BUTTON }}
                  </button>
                </form>
              </div>
            </div>
            <div class="admin-login-right">
              <div class="admin-login-right-in">
                <h2>{{ constants.FORGOT_PASSWORD_TEXT }}</h2>
                <p>
                  {{
                    constants.ENTER_THE_EMAIL_ASSOCIATED_WITH_YOUR_ACCOUNT_AND_WE_LL_SEND_AN_EMAIL_WITH_INSTRUCTIONS_TO_RESET_YOUR_PASSWORD_TEXT
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="admin-site-footer">
        <div class="container">
          {{ constants.COPYRIGHT_TEXT }}
        </div>
      </footer>
    </section>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import constants from "@/utils/en-US-Admin.json";
  import { API_BASE_URL } from '@/config/api.config';
  import axios from 'axios';

  export default defineComponent({
    name: 'ForgotPassword',
    data() {
      return {
        email: '',
        constants,
        errorMsg: ''
      };
    },
    methods: {
      async sendEmail() {
        if (!this.email) {
          this.errorMsg = 'This field is required';
          return;
        }
        try {
          const response = await axios.post(API_BASE_URL + '/send-link/', {
            email: this.email
          });
          if (response.status === 200) {
            this.$router.push({ path: '/authority/email-sent', query: { email: this.email } });
          }
        } catch (error: any) {
          this.errorMsg = "Email not registered.";
          console.log(error);
        }
      }
    }
   
  });
  </script>